export default "__VITE_ASSET__5Ik$q3A0__"